import React from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import {PATHS} from '../../Routes';
import experiencesImg from 'assets/img/status-experiences-icon.png';
import {
  ModalStyled,
  Row,
  ModalHeader,
  ModalBody,
  ButtonStyled,
} from './ExperiencesModalStyle';

type ExperiencesModalProps = {
  onCloseModal: () => void;
};
function ExperiencesModal({onCloseModal}: ExperiencesModalProps) {
  const {t} = useTranslation();
  const history = useHistory();

  const handleExperiencesButton = () => {
    history.push(PATHS.experiences);
  };
  const handleLaterButton = () => {
    onCloseModal();
  };

  return (
    <ModalStyled>
      <ModalHeader>
        <Row>
          <img src={experiencesImg} alt="Experiences" />
        </Row>
        <Row className="modalTitle">
          <span>{t('make_your_experience_unforgettable')}</span>
        </Row>
      </ModalHeader>
      <ModalBody>
        <Row>
          <ButtonStyled
            label={t('explore_all_experiences')}
            onClick={() => handleExperiencesButton()}
          />
        </Row>
        <Row>
          <div className="link" onClick={handleLaterButton}>
            {t('maybe_later')}
          </div>
        </Row>
      </ModalBody>
    </ModalStyled>
  );
}

export {ExperiencesModal};
